



























































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import CategoryButton from '@/top/components/CategoryButton.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { TextLink } from '@raksul/raksul-common-ui'


export default Vue.extend({
  name: 'SidebarCategory',
   components: {
    CategoryButton,
    BaseImage,
    TextLink
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    }
  },
  data(): {
    activeMenuId: number,
  } {
    return {
      activeMenuId: 0
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  methods: {
    setActiveItem(value: number){
      this.activeMenuId = value
    },
    removeActiveItem(){
      this.activeMenuId = 0
    }
  }
})
